module.exports = __webpack_public_path__ + "img/-LV55Jf_4GjmRfTT7GA7.f3057b87.jpg";